import EventBus from '@vue-storefront/core/compatibility/plugins/event-bus'

/**
 * Hover delays plus exclusive open state for megamenu columns.
 * Invalidates in-flight async hoverstarts (e.g. category fetches) after mouseleave
 * so the panel cannot reopen once the pointer has already left.
 */
export default function megamenuHoverMixin (group) {
  return {
    data () {
      return {
        hovered: false,
        hoverSession: 0
      }
    },
    created () {
      this._onMegamenuHover = ({ group: hoverGroup, uid }) => {
        if (hoverGroup !== group || uid === this._uid) return
        this.cancelMegamenuHover(true)
      }
      this._onMegamenuCloseAll = () => {
        this.cancelMegamenuHover(true)
      }
      EventBus.$on('megamenu-hover', this._onMegamenuHover)
      EventBus.$on('megamenu-close-all', this._onMegamenuCloseAll)
    },
    beforeDestroy () {
      EventBus.$off('megamenu-hover', this._onMegamenuHover)
      EventBus.$off('megamenu-close-all', this._onMegamenuCloseAll)
      this.cancelMegamenuHover(true)
    },
    methods: {
      cancelMegamenuHover (hide) {
        this.hoverSession += 1
        if (this.timerin) {
          clearTimeout(this.timerin)
          this.timerin = null
        }
        if (this.timerout) {
          clearTimeout(this.timerout)
          this.timerout = null
        }
        if (hide) {
          this.hovered = false
        }
      },
      async hoverstart () {
        const session = ++this.hoverSession
        if (typeof this.beforeMegamenuHover === 'function') {
          await this.beforeMegamenuHover()
          if (session !== this.hoverSession) return
        }
        if (this.timerout) {
          clearTimeout(this.timerout)
          this.timerout = null
        }
        this.timerin = setTimeout(() => {
          if (session !== this.hoverSession) return
          this.hovered = true
          EventBus.$emit('megamenu-hover', { group, uid: this._uid })
        }, 250)
      },
      hoverend () {
        const session = ++this.hoverSession
        if (this.timerin) {
          clearTimeout(this.timerin)
          this.timerin = null
        }
        this.timerout = setTimeout(() => {
          if (session !== this.hoverSession) return
          this.hovered = false
        }, 250)
      }
    }
  }
}
